<template>
  <div class="contact-edit">
    <el-card class="contact-main">
      <div slot="header">
           <el-page-header @back="$router.push('/changjing?active=1')" :content="`${creatable ? '新增' : '编辑'}渠道方信息`"></el-page-header>
        <div>
          <!-- <el-button type="primary" @click="deleteAllContact">全部清空</el-button> -->
          <!-- <el-button type="primary" @click="addPerson">新增名片</el-button> -->
        </div>
      </div>
      <el-form ref="form" :model="form">
         <el-form-item label="渠道" label-width="50px">
          <el-select
          v-model="id"
          filterable
          remote
          reserve-keyword
          placeholder="请输入渠道名搜索"
          :remote-method="remoteMethod"
          style="width:250px;"
          :disabled="!creatable">
          <el-option
            v-for="item in nameOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
        <el-row>
            <el-col v-for="(item, index) in contact" :key="index" class="contact-col">
              <el-card :body-style="{ padding: '10px' }" class="contact-card">
                 <div slot="header">
                    <span>名片{{index+1}}</span>
                    <el-button type="text" @click="deleteContact(index,item)">删除</el-button>
                  </div>
                <div>

                  <div class="contact-flex">
                    <el-input v-model="item.name" placeholder="请输入姓名" class="contact-name"></el-input>
                    <el-input v-model="item.mobile" placeholder="请输入联系方式" class="contact-mobile" maxlength="11"></el-input>
                  </div>
                  <el-input v-model="item.post" placeholder="请输入职位" class="contact-post"></el-input>
                  <el-input v-model="item.companyName" type="textarea" placeholder="请输入公司全称,多个用英文逗号隔开" class="contact-company-name"></el-input>
                  <el-input v-model="item.companyAddress" type="textarea" placeholder="请输入公司地址,多个用英文逗号隔开" class="contact-company-address"></el-input>
                   <el-input v-model="item.remark" type="textarea" placeholder="请输入其他信息" class="contact-company-address"></el-input>
                </div>
                <div class="tr">
                    <el-button type="primary" @click="submitContact(item,index)" :loading="loading[index]">提交</el-button>
                </div>
              </el-card>
            </el-col>
             <el-col class="contact-col">
              <el-card :body-style="{ padding: '10px' }" class="add-card" @click.native="addPerson">
                <div>
                  <i class="el-icon-plus"></i>
                  <div>新增名片</div>
                </div>
              </el-card>
            </el-col>
          </el-row>
          <!-- <div>
              <el-button type="primary" @click="submitContact" :loading="loading">提交</el-button>
              <el-button @click="$router.push('/changjing?active=1')">取消</el-button>
          </div> -->
      </el-form>
    </el-card>
  </div>
</template>

<script>
// import http from '@/plugins/axios'
import { Notification } from 'element-ui'
const contactInit = {
  name: '',
  mobile: '',
  post: '',
  companyName: '',
  companyAddress: ''
}
export default {
  data() {
    return {
      loading: [false],
      contact: [this.$utils.cloneDeep(contactInit)],
      id: '',
      form: {},
      nameOptions: [],
      detail: {}
    }
  },
  computed: {
    creatable() { return +this.$route.params.id === 0 }
  },
  methods: {
    remoteMethod(name) {
      if (name !== '') {
        this.$http.post('/changjing/list', { name }).then(res => {
          this.nameOptions = res.data.data
        })
      } else {
        this.nameOptions = []
      }
    },
    // deleteAllContact() {
    //   this.$_confirm({
    //     name: '全部清空',
    //     operate: () =>
    //       this.$http.post('/corpmessage/delete', {
    //         system: 'changjing',
    //         id: this.id
    //       }),
    //     callback () {
    //       this.contact = [cloneDeep(contactInit)]
    //     }
    //   })
    // },
    deleteContact(index, item) {
      this.$_confirm({
        name: '删除',
        operate: () =>
          this.$http.post('/corpmessage/delete', {
            system: 'changjing',
            id2: item.id2
          }).then(() => {
            if (this.contact && this.contact.length === 0) {
              this.contact = [this.$utils.cloneDeep(contactInit)]
            } else {
              this.contact.splice(index, 1)
            }
          })
      })
    },
    addPerson() {
      this.contact.push(this.$utils.cloneDeep(contactInit))
    },
    submitContact(item, index) {
      let params = JSON.parse(JSON.stringify(item))
      if (!this.id) {
        Notification.error({ title: '失败', message: '请先选择渠道' })
        return
      }
      if (!params.name && !params.mobile && params.id2) {
        this.$http.post('/corpmessage/delete', {
          system: 'changjing',
          id: this.id
        })
      } else if (!params.name && !params.mobile) {
        return
      }
      this.$set(this.loading, index, true)
      params = JSON.stringify(params)
      this.$http.post('/corpmessage/add', { 'system': 'changjing', 'id': this.id, remark: params, responsor: this.detail.responsor }).then(res => {
        if (res.successful) {
          item.id2 = res.data.id2
        }
        this.$set(this.loading, index, false)
      })
    }
  },
  created() {
    const id = +this.$route.params.id
    if (id !== 0) {
      this.$http.post('/changjing/jdetail', {
        id
      }).then(res => {
        this.id = id
        this.detail = res.data.data[0]
        this.remoteMethod(this.detail.name)
        this.$http.post('/corpmessage/get', {
          id,
          system: 'changjing'
        }).then(res => {
          res.data.data.forEach(data => {
            if (data.id === id) {
              this.contact = data.message.map(message => {
                message.remark.id2 = message.id2
                return message.remark
              })
              this.contact.length && (this.loading = this.contact.map(() => { return false }))
            }
          })
        })
      })
    }
  }
}
</script>

<style lang="scss">
.contact-edit {
  .el-page-header{
    border-bottom:none;
  }
  .add-card{
    padding: 10px;
    height: 344px;
    display: flex;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #999;
    text-align:center;
    i{
      font-size: 34px;
      padding-bottom:10px;
    }
  }
  .el-card__header > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .tr{
    text-align:right;
  }
  .contact-main{
    >.el-card__body{
      padding-right:0;
    }
    .contact-card{
      .el-input,
      .el-textarea{
        width:100%;
        margin-bottom:5px;
      }
      .el-card__header .el-button--text{
        padding:0;
      }
    }
    .contact-col{
      width:300px;
      margin-right:20px;
      margin-bottom:20px;
      .el-input--small .el-input__inner {
          border: none;
          border-bottom: 1px solid #DCDFE6;
          border-radius: 0;
      }
    }
    .contact-flex{
      display: flex;
      >div{
        flex:1;
      }
    }
    .contact-name{
    }
    .contact-mobile{
        margin-left: 10px;
    }
  }
}
</style>
